// extracted by mini-css-extract-plugin
module.exports = {"innerContainer":"_2BuZo","buildHomeDepositFaster":"_37klk","testimonialsArea":"BZEfH"};